import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../base/Button';

export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-dark/95 backdrop-blur-md shadow-lg shadow-primary/10' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-primary to-primary-dark rounded-xl">
            <i className="ri-robot-2-line text-2xl text-white"></i>
          </div>
          <span className="text-xl font-display font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">Digital Line AI</span>
        </Link>
        
        <div className="hidden md:flex items-center gap-10">
          <button 
            onClick={() => scrollToSection('agentes')}
            className="text-sm font-medium text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
          >
            Agentes
          </button>
          <button 
            onClick={() => scrollToSection('como-funciona')}
            className="text-sm font-medium text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
          >
            Cómo funciona
          </button>
          <button 
            onClick={() => scrollToSection('precios')}
            className="text-sm font-medium text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
          >
            Precios
          </button>
          <Link 
            to="/demo"
            className="text-sm font-medium text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
          >
            Demo
          </Link>
          <Link 
            to="/login"
            className="text-sm font-medium text-white hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
          >
            Iniciar sesión
          </Link>
          <button 
            onClick={() => scrollToSection('demo-form')}
            className="px-6 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-cyan-400 to-pink-500 rounded-lg hover:shadow-lg hover:shadow-pink-500/30 transition-all cursor-pointer whitespace-nowrap"
          >
            Reserva cita +info
          </button>
        </div>
      </div>
    </nav>
  );
}